import Cookies from 'js-cookie';
import axios from "axios";

export default {
    fbPixelEvent(eventType, eventName, customData = {}, eventData = {}) {
        if (window.config.debug) return null;

        if (!eventType || !eventName) return null;

        const data = {
            eventName: eventName,
            customData: customData,
            eventData: eventData,
            fbp: Cookies.get('_fbp'),
            fbc: Cookies.get('_fbc'),
        };

        axios.post('/analytics/conversions-api', data).then(response => {
            eventData.eventID = response.data.eventID;
            fbq(eventType, eventName, customData, eventData);
        });
    },

    gtmDataLayer(event, items = {}, additionalData = {}) {
        if (window.config.debug) return null;

        if (!event) return null;

        const data = {
            event: event,
            ecommerce: {
                ...additionalData,
                items: Array.isArray(items) ? items : [items],
            },
        };

        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        window.dataLayer.push(data);
    }
}
